import { create } from 'zustand';

export const useAuthStore = create((set) => ({
    authData: {
        clientId: null,
        eventId: null,
        accountId1: null,
        accountId2: null,
        accessToken: null,
        _guard_: null,
        systemToken: null,
    },
    // True once the session was logged out (countdown ran out, a renewal
    // failed or an API rejected the token). Only a page reload clears it.
    sessionExpired: false,
    setAuthData: (data) => set({ authData: { ...data } }),
    expireSession: () =>
        set((state) => ({
            sessionExpired: true,
            authData: {
                ...state.authData,
                accessToken: null,
                systemToken: null,
                refreshToken: null,
            },
        })),
}));
